import type { SaasOrg } from './saasOrg';
import { getAppMode } from '../appMode';
import {
  DEFAULT_PLATFORM_BUSINESS_DEFAULTS,
  parsePlatformBusinessDefaults,
  resolveOrgSettings,
  type CompanySettingsSnapshot,
  type PlatformBusinessDefaults,
  type ResolvedOrgSettings,
} from './resolveOrgSettings';
import { fetchOrgCompanySettingsRow } from './orgCompanySettings';

export async function fetchPlatformBusinessDefaults(): Promise<PlatformBusinessDefaults> {
  // toolsandbubbles.com has no SaaS billing API — avoid noisy 500s on admin dashboards.
  if (getAppMode() === 'tb-site') {
    return DEFAULT_PLATFORM_BUSINESS_DEFAULTS;
  }
  try {
    const res = await fetch('/api/saas/billing-status');
    if (!res.ok) return DEFAULT_PLATFORM_BUSINESS_DEFAULTS;
    const data = await res.json();
    return parsePlatformBusinessDefaults(data.platform_business_defaults);
  } catch {
    return DEFAULT_PLATFORM_BUSINESS_DEFAULTS;
  }
}

export async function fetchCompanySettingsSnapshot(orgId: string): Promise<CompanySettingsSnapshot | null> {
  return fetchOrgCompanySettingsRow<CompanySettingsSnapshot>(
    orgId,
    'company_name, logo_url, tagline, phone, email, timezone, currency, address_line1, city, state, pincode, organization_id',
  );
}

export async function fetchOrgSettingsSnapshot(
  org: SaasOrg,
  platform?: PlatformBusinessDefaults,
): Promise<ResolvedOrgSettings> {
  const platformDefaults = platform ?? (await fetchPlatformBusinessDefaults());
  const company = await fetchCompanySettingsSnapshot(org.id);
  return resolveOrgSettings({
    orgId: org.id,
    orgLocale: org.locale,
    orgSettings: org.settings,
    companySettings: company,
    platform: platformDefaults,
  });
}
